var _defs, _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerminalNotActivated = function SvgTerminalNotActivated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10.83 19.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.85px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.43,
    y: 0.43,
    width: 9.98,
    height: 19.03,
    rx: 1.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.93,13.35a.27.27,0,0,0,.2.08.28.28,0,0,0,.21-.08.28.28,0,0,0,0-.4l-2-2,.86-1.23a.4.4,0,0,0,.07-.21.36.36,0,0,0-.36-.36H10.38L10.64,7V7a.36.36,0,0,0-.36-.35.36.36,0,0,0-.29.15L8.84,8.45,7.07,6.68a.3.3,0,0,0-.41,0,.28.28,0,0,0,0,.4Z",
    transform: "translate(-4.59 -0.07)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79,10a.44.44,0,0,0-.07.22.36.36,0,0,0,.36.35H9.34L9.08,13a.06.06,0,0,0,0,0,.36.36,0,0,0,.36.35.37.37,0,0,0,.29-.14l1-1.5L8.28,9.3Z",
    transform: "translate(-4.59 -0.07)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerminalNotActivated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terminal-not-activated.4e1db883.svg";
export { ForwardRef as ReactComponent };